export class IntegratorRequest {
	pk: string; //venueKey

	sk: string; //IR_INTEGRATOR_{requestId}

	requestId: string;

	status: string;

	created: string;

	updated: string;

	integratorResponseStatusCode: number;

	integratorResponseMessage: string;

	integrator: string;

	public constructor(init?: Partial<IntegratorRequest>) {
		Object.assign(this, init);
	}
}
